export const PORTAL_DICTIONARY = {
  en: {
    createAnOrder: 'CREATE AN ORDER',
    createAnOrderIt: 'Create An Order',
    cart: 'MY CART',
    legalClause: 'Legal clause',
    backUp: 'Back up',
    menu: 'Menu',
    tutorial: 'Tutorial',
    home: 'Homepage',
    profile: 'My Profile',
    contracts: 'Contracts',
    orders: 'Orders',
    history: 'History',
    deliveryPlan: 'Delivery plan',
    savedOrders: 'Saved Orders',
    catalog: 'Catalogue',
    products: 'Create an order',
    bulkUpload: 'Order Bulk Upload',
    favorites: 'My Favourites',
    favoritesMenu: 'MY FAVOURITES',
    oldPortal: 'OLD PORTAL',
    reporting: 'Reporting',
    myDocuments: 'My documents',
    marketingMaterials: 'Marketing Materials',
    newsEvents: 'News & Events',
    aboutUrsusMenu: 'About Ursus',
    support: 'Support',
    faq: 'FAQ',
    knowledgeBase: 'Knowledge Base',
    supportTickets: 'Other Requests',
    eLearning: 'Academy',
    pubMenu: 'Menu Creator',
    emptiesManagement: 'Empties Management',
    contacts: 'Contacts',
    about: 'ABOUT US',
    privacyPolicy: 'Privacy Policy',
    privacyProtection: 'Privacy Protection',
    cookies: 'Cookies and personal data protection',
    brands: 'BRANDS',
    aboutAsahiFB: 'Asahi',
    productCode: 'Product code',
    removeItem: 'Remove Item',
    createNewUser: 'Create New User',
    trainingLearning: 'Training & Learning',
    dailySales: 'Daily sales of beer',
    dailyStocksOfEmpties: 'Daily stocks of empties',
    dailyStocks: 'Daily stocks of beer',
    deliveryPlanReport: 'Delivery Plan',
    mainDashboard: 'Main Dashboard',
    mainSalesDashboard: 'Sales Dashboard',
    emptiesReturn: 'Empties status',
    selloutAccuracy: 'Sell Out accuracy',
    Stocks: 'Beer stocks DOH',
    stockAccuracy: 'Stock accuracy',
    invoicedUniverse: 'Invoiced customers',
    mapping: 'Customers and products mapping',
    volumes: 'Sell Out and Free Beer',
    structureOfTheUniverse: 'Mapped customers',
    portfolio: 'Invoiced products',
    reportingStatus: 'Reporting status by days',
    Unit: 'Unit',
    actions: {
      edit: 'My Profile',
      logout: 'Logout'
    },
    languages: {
      ro: 'Romana',
      en: 'English'
    },
    login: 'Login',
    goToCart: 'GO TO CART',
    notificationsEmpty: 'No notifications',
    termsOfUse: 'Terms of use',
    corporateInformation: 'Corporate Information',
    corporateGovernance: 'Corporate Governance',
    containerManager: 'Container Management'
  },
  ro: {
    createAnOrder: 'COMANDA NOUA',
    administration: 'Administrace',
    cart: 'COSUL MEU',
    home: 'Acasa',
    profile: 'Profilul meu',
    contracts: 'Contracte',
    orders: 'Comenzi',
    history: 'Istoric comenzi',
    deliveryPlan: 'Plan de livrare',
    savedOrders: 'Comenzi salvate',
    catalog: 'Catalog produse',
    products: 'Comanda noua',
    bulkUpload: 'Comanda Bulk',
    favorites: 'Favorite',
    favoritesMenu: 'FAVORITE',
    oldPortal: 'PORTALUL VECHI',
    backUp: 'Back up',
    reporting: 'Rapoarte',
    aboutAsahiFB: 'Asahi',
    myDocuments: 'Documentele mele',
    marketingMaterials: 'Materiale Marketing',
    newsEvents: 'Noutati & Evenimente',
    aboutUrsusMenu: 'Despre Ursus',
    support: 'Suport',
    faq: 'Intrebari frecvente',
    knowledgeBase: 'Cunostinte de baza',
    supportTickets: 'Alte solicitari',
    eLearning: 'Academie',
    pubMenu: 'Generator Meniuri',
    legalClause: 'Právna doložka',
    menu: 'Menu',
    tutorial: 'Tutorial',
    contacts: 'Contacto',
    about: 'DESPRE NOI',
    privacyPolicy: 'Politica Confidentialitate',
    privacyProtection: 'Protección de la privacidad',
    cookies: 'Cookies y Protección de Datos Personales',
    brands: 'BRANDURI',
    productCode: 'kód produktu',
    createNewUser: 'Vytvoriť nového užívateľa',
    trainingLearning: 'Training & Learning',
    dailySales: 'Vanzari zilnice de bere',
    dailyStocksOfEmpties: 'Stocuri zilnice de ambalaje',
    dailyStocks: 'Stocuri zilnice de bere',
    deliveryPlanReport: 'Plan de livrari',
    mainDashboard: 'Dashboard principal',
    mainSalesDashboard: 'Dashboard vânzări',
    emptiesReturn: 'Status ambalaje',
    selloutAccuracy: 'Acuratete Sell Out',
    Stocks: 'Stocuri bere DOH',
    stockAccuracy: 'Acuratete stoc',
    invoicedUniverse: 'Clienti facturati',
    mapping: 'Mapare clienti si produse',
    volumes: 'Volume Sell Out si Free Beer',
    structureOfTheUniverse: 'Clienti mapati',
    portfolio: 'Produse facturate',
    reportingStatus: 'Status raportare pe zile ',
    Unit: 'Unitati',
    actions: {
      edit: 'Profilul meu',
      logout: 'Delogheaza-te'
    },
    languages: {
      ro: 'Romana',
      en: 'English'
    },
    goToCart: 'CATRE COSUL DE CUMPARATURI',
    removeItem: 'eliminar producto',
    login: 'Logheaza-te',
    notificationsEmpty: 'Žiadne notifikácie',
    termsOfUse: 'Termeni & Conditii',
    containerManager: 'Managementul ambalajelor'
  }
}
